import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useState } from 'react';

type Props = {
  keyword: string;
  handleChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const MemberSearchPanel: React.FC<Props> = ({ keyword, handleChangeKeyword }: Props) => {
  return (
    <div className="relative p-2">
      <div className="flex min-w-0 flex-1">
        <input
          value={keyword}
          onChange={handleChangeKeyword}
          type="text"
          className="min-w-0 flex-1 rounded-md border-2 border-gray-400 py-1 pr-2 placeholder:text-sm focus:outline-none"
          placeholder="検索"
          style={{ paddingInlineStart: '24px' }}
        />
      </div>
      <FontAwesomeIcon
        icon={faSearch}
        className="absolute flex-none text-gray-600"
        style={{ top: '20px', left: '14px' }}
      />
    </div>
  );
};

type HookReturnType = [
  component: typeof MemberSearchPanel,
  componentProps: Props,
  memberFilter: (name: string) => boolean,
  resetMemberFilter: () => void,
];

export const useMemberFilter = (): HookReturnType => {
  const [keyword, setKeyword] = useState<string>('');

  const handleChangeKeyword = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(e.target.value);
    if (!e.target.value) {
      setKeyword('');
    }
  }, []);

  const memberFilter = useCallback(
    (name: string) => {
      return name.toLocaleLowerCase().includes(keyword.toLocaleLowerCase());
    },
    [keyword]
  );

  const resetMemberFilter = () => setKeyword('');

  return [MemberSearchPanel, { keyword, handleChangeKeyword }, memberFilter, resetMemberFilter];
};
